import PatientUserService from '../services/patientUser.service';

const patientUser = {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    register(_, user) {
      return PatientUserService.register(user);
    },
    update({ dispatch, rootGetters }, user) {
      return PatientUserService.update(user).then((userUpdated) => {
        const oldUser = rootGetters['auth/getUser'];
        const usr = Object.assign(oldUser, userUpdated);
        dispatch('auth/updateUser', usr, { root: true });
      });
    },
    uploadAvatar({ dispatch, rootGetters }, { patientId, base64Image }) {
      return PatientUserService.uploadAvatar(patientId, base64Image).then((res) => {
        const user = rootGetters['auth/getUser'];
        user.avatar = res.avatar;
        user.updatedAt = res.updatedAt;
        dispatch('auth/updateUser', user, { root: true });
        return res;
      });
    },
    deactivate(_, { patientId, password }) {
      return PatientUserService.deactivate(patientId, password);
    },
    changePassword(_, { patientId, password, newPassword }) {
      return PatientUserService.changePassword(patientId, password, newPassword).then();
    },
    resetPassword(_, { token, phoneOrEmail, password }) {
      return PatientUserService.resetPassword(token, phoneOrEmail, password).then();
    },
    verify(_, { code }) {
      return PatientUserService.verify(code).then();
    },
  },

  getters: {},
};

export default patientUser;
